// Module
var code = "<div class=\"contact-employment-scenario\"> <table-list table-title=\"{{vm.employmentTitle}}\" column-header=\"vm.columnHeader\" column-content=\"vm.columnContent\" grid-template=\"vm.gridTemplate\" edit-handler=\"vm.editHandler\" delete-handler=\"vm.deleteHandler\"> </table-list> </div> ";
// Exports
module.exports = code;